import { render, staticRenderFns } from "./areadialog.vue?vue&type=template&id=fae0629e&scoped=true"
import script from "./areadialog.vue?vue&type=script&lang=js"
export * from "./areadialog.vue?vue&type=script&lang=js"
import style0 from "./areadialog.vue?vue&type=style&index=0&id=fae0629e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae0629e",
  null
  
)

export default component.exports